export default __webpack_public_path__ + "static/media/Myimg.9ec28a37.png";